import { render, staticRenderFns } from "./CountryType.vue?vue&type=template&id=063405ce&"
import script from "./CountryType.vue?vue&type=script&lang=js&"
export * from "./CountryType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports